<sb-icon *ngIf="option === true" icon="success" container="body"
         class="green">
</sb-icon>
<sb-icon *ngIf="option === false" icon="error" container="body"
         class="red">
</sb-icon>
<sb-icon
  *ngIf="option === undefined || option === null"
  icon="questionmark" container="body"
  [ngbTooltip]="'n. def.'"
  class="tw-cursor-help tw-opacity-20">
</sb-icon>
